// import { useEffect } from 'react';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// // material
// import { Box, Divider } from '@material-ui/core';
// // redux
// import { useDispatch, useSelector } from '../../../../redux/store';
// import {
//   addRecipients,
//   onSendMessage,
//   getConversation,
//   getParticipants,
//   markConversationAsRead,
//   resetActiveConversation
// } from '../../../../redux/slices/chat';
// // routes
// //
// import { PATH_DASHBOARD } from 'src/routes/paths';
// import ChatRoomSignWise from './ChatRoomSignWise';
// import ChatHeaderDetailSignWise from './ChatHeaderDetailSignWise';
// import ChatHeaderComposeSignWise from './ChatHeaderComposeSignWise';
// import ChatMessageListSignWise from './ChatMessageList';
// import ChatMessageInputSignWise from './ChatMessageInputSignWise';

// // ----------------------------------------------------------------------

// const conversationSelector = (state) => {
//   const { conversations, activeConversationId } = state.chat;
//   const conversation = conversations.byId[activeConversationId];
//   if (conversation) {
//     return conversation;
//   }
//   return {
//     id: null,
//     messages: [],
//     participants: [],
//     unreadMessages: 0
//   };
// };

// export default function ChatScreenWindow({contact,openCompose,setCompose}) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { pathname } = useLocation();
//   // const { conversationKey } = useParams();
//   const conversationKey = contact
//   const { contacts, recipients, participants, activeConversationId } = useSelector((state) => state.chat);
//   const conversation = useSelector((state) => conversationSelector(state));
//   const mode = openCompose ? 'COMPOSE' : 'DETAIL';
//   console.log('openCompose2', openCompose)
//   console.log('conversationKey', conversationKey,mode)
//   console.log('activeConversationId', activeConversationId)

//   const displayParticipants = participants.filter((item) => item.id !== '8864c717-587d-472a-929a-8e5f298024da-0');

//   useEffect(() => {
//     const getDetails = async () => {
//       dispatch(getParticipants(conversationKey));
//       try {
//         dispatch(getConversation(conversationKey));
//       } catch (error) {
//         console.error(error);
//         navigate(PATH_DASHBOARD.chatSignwise.new);
//       }
//     };
//     if (conversationKey) {
//       getDetails();
//     } else if (activeConversationId) {
//       dispatch(resetActiveConversation());
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [conversationKey]);

//   useEffect(() => {
//     if (activeConversationId) {
//       dispatch(markConversationAsRead(activeConversationId));
//     }
//   }, [dispatch, activeConversationId]);

//   const handleAddRecipient = (recipient) => {
//     dispatch(addRecipients(recipient));
//   };

//   const handleSendMessage = async (value) => {
//     try {
//       dispatch(onSendMessage(value));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
//       {mode === 'DETAIL' ? (
//         <ChatHeaderDetailSignWise participants={displayParticipants} />
//       ) : (
//         <ChatHeaderComposeSignWise
//           recipients={recipients}
//           contacts={Object.values(contacts.byId)}
//           onAddRecipient={handleAddRecipient}
//         />
//       )}

//       <Divider />

//       <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
//         {!openCompose &&(<Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
//           <ChatMessageListSignWise conversation={conversation} />

//           <Divider />

//           <ChatMessageInputSignWise
//             conversationId={activeConversationId}
//             onSend={handleSendMessage}
//             disabled={pathname === PATH_DASHBOARD.chatSignwise.new}
//           />
//         </Box>)}

//         {mode === 'DETAIL' && <ChatRoomSignWise conversation={conversation} participants={displayParticipants} />}
//       </Box>
//     </Box>
//   );
// }


import { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Divider, Typography } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import ChatHeaderDetailSignWise from './ChatHeaderDetailSignWise';
import ChatMessageListSignWise from './ChatMessageList';
import ChatMessageInputSignWise from './ChatMessageInputSignWise';
import ChatHeaderComposeSignWise from './ChatHeaderComposeSignWise';
import ChatRoomSignWise from './ChatRoomSignWise';
import axios from 'axios';
import { DOMAIN, REST_API_END_POINT } from 'src/constants/DefaultValues';
import { WA } from '../whatsappTheme';
import { createChatSocket } from 'src/Helpers/createSocket';
import { downloadChatTranscript } from '../chatWidgetPrefs';
import { buildReplyTo } from '../chatReply';
import {
  START_CHAT_MESSAGE,
  JOIN_GREETING,
  END_CHAT_MESSAGE,
  getHelpDeskChatStartedInSession,
  getLatestSessionMessages,
  getMessagesForContact,
  hasPendingUserMessage,
  hasEndedChat,
  isEndMessage,
  getLastHelpDeskOnlineStatus,
} from '../helpDeskSession';

const HELP_DESK_USER_ID = 39

export default function ChatScreenWindow({compact = false, setOnChatScreen, contact,setSelectedContact,setRenderChat,renderChat,handleRefresh,openCompose, setCompose,conversationKey,teamMembers,refreshChat,chatOpenTime,setChatOpenTime,historyMessage,setHistoryMessage,selectedChatLogId,newChat,setNewChat, maximized = false, onToggleMaximize, notificationsEnabled = true, onToggleNotifications, onTranscriptMessages }) {
  const [chatLogId, setChatLogId] = useState(null);
  const [message, setMessage] = useState('');
  const [image,setImage] = useState([])
  const [messages, setMessages] = useState([]);
  const [openSidebarRoom, setOpenSidebarRoom] = useState(!compact);
  const [groupName, setGroupName] = useState('');
  let user = JSON.parse(localStorage.getItem('user'))
  const fetchMessagesRef = useRef(null)
  const handleRefreshRef = useRef(handleRefresh)
  const markedReadIdsRef = useRef(new Set())
  handleRefreshRef.current = handleRefresh
  const messagesFingerprintRef = useRef('')
  const endingChatRef = useRef(false)
  const conversationId = (contact?.conversation_type == "single") ? contact?.user_id : contact?.conversation_id || contact?.id
  const conversationIdForEvent =
    contact?.conversation_type === 'group'
      ? contact?.new_conversation_id || `chat_${contact?.conversation_id || contact?.id}`
      : contact?.new_conversation_id || contact?.conversation_id || contact?.id
  const conversationTypeValue = contact?.conversation_type == "single" ? 1 : 2

  console.log('contact@$^groupName', groupName)
  const handleOpensidebar = () => {
    setOpenSidebarRoom(!openSidebarRoom);
  };
  // const mode = conversationKey ? 'DETAIL' : 'COMPOSE';
  console.log('messages+++++++++', messages)

  const [chat, setChat] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [typingUser, setTypingUser] = useState("");
  const [chatStartedLocal, setChatStartedLocal] = useState(false);
  const [startingChat, setStartingChat] = useState(false);
  const [endingChat, setEndingChat] = useState(false);
  const [confirmEndOpen, setConfirmEndOpen] = useState(false);
  const [helpDeskOnline, setHelpDeskOnline] = useState(false);
  const [helpDeskStatusNotices, setHelpDeskStatusNotices] = useState([]);
  const prevHelpDeskOnlineRef = useRef(helpDeskOnline);
  const helpDeskStatusTrackingReadyRef = useRef(false);
  const [chatRating, setChatRating] = useState(null);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [replyTo, setReplyTo] = useState(null);
  const startChatSocketRef = useRef(null);
  const contactRef = useRef(contact)
  contactRef.current = contact
  const conversationIdRef = useRef(conversationId)
  conversationIdRef.current = conversationId
  const conversationIdForEventRef = useRef(conversationIdForEvent)
  conversationIdForEventRef.current = conversationIdForEvent

  const listShowsPendingCustomerMessage =
    compact &&
    Boolean(contact?.last_message) &&
    contact?.last_message_type !== 'end' &&
    String(contact?.last_message || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .trim() !== END_CHAT_MESSAGE &&
    Number(contact?.chat_started) !== 1

  const hasPendingReceived =
    hasPendingUserMessage(messages, 'received') ||
    (messages.length === 0 && listShowsPendingCustomerMessage)

  const chatStartedFromMessages = getHelpDeskChatStartedInSession(messages);
  const chatStarted =
    !compact ||
    chatStartedFromMessages ||
    chatStartedLocal ||
    (messages.length === 0 && Number(contact?.chat_started) === 1);
  const sessionEnded =
    compact &&
    !chatStarted &&
    hasEndedChat(messages) &&
    !hasPendingReceived
  const waitingForUserMessage =
    compact &&
    !chatStarted &&
    !hasPendingReceived;
  const displayMessages = compact ? getMessagesForContact(messages, contact, true) : messages;
  const onTranscriptMessagesRef = useRef(onTranscriptMessages)
  onTranscriptMessagesRef.current = onTranscriptMessages

  useEffect(() => {
    // Never reuse another session's rating from the contact list
    setChatRating(null)
  }, [contact?.user_id, contact?.conversation_id, contact?.openedAt])

  useEffect(() => {
    onTranscriptMessagesRef.current?.(displayMessages)
  }, [messages, compact])

  useEffect(() => {
    const socket = createChatSocket();
    startChatSocketRef.current = socket;
    const onMessageRead = (payload) => {
      const ids = new Set((payload?.messageIds || []).map((id) => Number(id)))
      if (!ids.size) return
      const myId = Number(user?.user_id)
      const readBy = Number(payload?.readByUserId)
      const openContact = contactRef.current
      if (openContact?.conversation_type === 'group') {
        // Only refetch when another member read — updates sent-message ticks
        if (readBy && readBy !== myId) {
          fetchMessagesRef.current?.({ silent: true })
        }
        return
      }
      setMessages((prev) =>
        prev.map((item) => (ids.has(Number(item.id)) ? { ...item, read_status: 0 } : item)),
      )
    }
    const onMessage = (msg) => {
      if (msg?.contentType !== 'chat_rating' || !msg?.rating) return
      const openContact = contactRef.current
      if (!openContact) return
      const incoming = String(msg.conversationId || '')
      const openEventId = String(conversationIdForEventRef.current || '')
      const openConvId = String(conversationIdRef.current || '')
      const matches =
        incoming === openEventId ||
        incoming === openConvId ||
        incoming === `chat_${openConvId}` ||
        (openContact.conversation_type === 'single' &&
          (incoming === `user_${openConvId}` ||
            Number(msg.senderId) === Number(openContact.user_id || openConvId)))
      if (!matches) return
      setChatRating({
        rating:
          msg.rating === 'skip' || msg.rating === 'skipped'
            ? 'skip'
            : msg.rating === 'up' || Number(msg.rating) === 1
            ? 'up'
            : 'down',
        created_at: Math.floor(Date.now() / 1000),
      })
      if (typeof handleRefreshRef.current === 'function') handleRefreshRef.current()
      // Re-fetch so rating persists if contact.chat_rating was empty
      fetchMessagesRef.current?.({ silent: true })
    }
    const onTyping = (data) => {
      if (data?.domain !== DOMAIN) return
      const openContact = contactRef.current
      if (!openContact) return
      const senderId = Number(data?.senderId)
      const myId = Number(user?.user_id)
      if (!senderId || senderId === myId) return

      const incoming = String(data?.conversationId || '')
      const openEventId = String(conversationIdForEventRef.current || '')
      const openConvId = String(conversationIdRef.current || '')
      const participants = Array.isArray(data?.participants) ? data.participants : []
      const isGroup = openContact.conversation_type === 'group' || incoming.startsWith('chat_')

      let matches = false
      if (isGroup) {
        const participantIds = participants.map((p) => Number(p.user_id ?? p.id))
        const inGroup =
          participantIds.length === 0 || participantIds.includes(myId)
        matches =
          inGroup &&
          (incoming === openEventId ||
            incoming === `chat_${openConvId}` ||
            incoming === String(openConvId))
      } else {
        const customerId = Number(openContact.user_id || openConvId)
        matches =
          incoming === openEventId ||
          incoming === `user_${customerId}` ||
          incoming === `user_${myId}` ||
          senderId === customerId
      }
      if (!matches) return
      setTypingUser(data.user || { user_id: senderId })
      setIsTyping(true)
    }
    const onStopTyping = (data) => {
      if (data?.domain !== DOMAIN) return
      const openContact = contactRef.current
      if (!openContact) return
      const senderId = Number(data?.senderId)
      const myId = Number(user?.user_id)
      if (!senderId || senderId === myId) return
      const incoming = String(data?.conversationId || '')
      const openEventId = String(conversationIdForEventRef.current || '')
      const openConvId = String(conversationIdRef.current || '')
      const isGroup = openContact.conversation_type === 'group' || incoming.startsWith('chat_')
      const matches = isGroup
        ? incoming === openEventId ||
          incoming === `chat_${openConvId}` ||
          incoming === String(openConvId)
        : incoming === openEventId ||
          incoming === `user_${openContact.user_id || openConvId}` ||
          incoming === `user_${myId}` ||
          senderId === Number(openContact.user_id || openConvId)
      if (!matches) return
      setIsTyping(false)
      setTypingUser('')
    }
    socket.on('message-read', onMessageRead)
    socket.on('message', onMessage)
    socket.on('typing', onTyping)
    socket.on('stop typing', onStopTyping)
    return () => {
      socket.off('message-read', onMessageRead)
      socket.off('message', onMessage)
      socket.off('typing', onTyping)
      socket.off('stop typing', onStopTyping)
    };
  }, []);

  useEffect(() => {
    if (!compact) return undefined

    const cached = getLastHelpDeskOnlineStatus()
    if (cached != null) {
      setHelpDeskOnline(cached)
    }

    const syncOnlineStatus = async () => {
      if (!user?.user_id) return
      try {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-user-active`, {
          userId: user.user_id,
        })
        if (response.data.status === 1) {
          const fromApi = response.data.data?.online === 1
          const latest = getLastHelpDeskOnlineStatus()
          setHelpDeskOnline(latest != null ? latest : fromApi)
        }
      } catch (error) {
        console.log('Error syncing help desk online status', error)
      }
    }
    syncOnlineStatus()

    const onOnlineStatus = (event) => {
      setHelpDeskOnline(event.detail?.online === true)
    }
    window.addEventListener('signwise-helpdesk-online', onOnlineStatus)
    return () => window.removeEventListener('signwise-helpdesk-online', onOnlineStatus)
  }, [compact])

  const helpDeskOnlineRef = useRef(false)
  helpDeskOnlineRef.current = helpDeskOnline

  useEffect(() => {
    if (!compact || !chatStarted) {
      prevHelpDeskOnlineRef.current = helpDeskOnline
      helpDeskStatusTrackingReadyRef.current = false
      if (!chatStarted) setHelpDeskStatusNotices([])
      return
    }
    if (!helpDeskStatusTrackingReadyRef.current) {
      prevHelpDeskOnlineRef.current = helpDeskOnline
      helpDeskStatusTrackingReadyRef.current = true
      return
    }
    const wasOnline = prevHelpDeskOnlineRef.current
    if (wasOnline && !helpDeskOnline) {
      setHelpDeskStatusNotices((prev) => [
        ...prev,
        { id: `help-desk-offline-${Date.now()}`, type: 'offline', created_at: Math.floor(Date.now() / 1000) },
      ])
    }
    if (!wasOnline && helpDeskOnline) {
      setHelpDeskStatusNotices((prev) => [
        ...prev,
        { id: `help-desk-online-${Date.now()}`, type: 'online', created_at: Math.floor(Date.now() / 1000) },
      ])
    }
    prevHelpDeskOnlineRef.current = helpDeskOnline
  }, [compact, chatStarted, helpDeskOnline])

  const contactKey = contact?.user_id || contact?.conversation_id || contact?.id

  // When help desk comes online with a chat open, mark unread as read (normal receipts).
  useEffect(() => {
    if (!compact || !helpDeskOnline || !contact) return undefined
    messagesFingerprintRef.current = ''
    fetchMessagesRef.current?.()
    return undefined
  }, [compact, helpDeskOnline, contactKey])

  const sessionSignal = compact
    ? `${contactKey || ''}:${contact?.openedAt || ''}`
    : `${contactKey || ''}:${selectedChatLogId || ''}:${newChat || ''}`
  const chatStartedRef = useRef(false)
  chatStartedRef.current = chatStarted

  useEffect(() => {
    if (contact) {
      messagesFingerprintRef.current = ''
      markedReadIdsRef.current = new Set()
      setChatStartedLocal(false)
      setEndingChat(false)
      endingChatRef.current = false
      setHelpDeskStatusNotices([])
      setMessages([])
      setChatRating(null)
      setReplyTo(null)
      fetchMessages();
      fetchGroupName(contact);
      setMessage('');
      setImage([]);
    }
  }, [contactKey, selectedChatLogId, newChat]);

  useEffect(() => {
    if (!compact || !contact) return undefined
    messagesFingerprintRef.current = ''
    fetchMessages()
    return undefined
  }, [sessionSignal]);

  const fetchMessages = async (opts = {}) => {
    const silent = opts && typeof opts === 'object' ? Boolean(opts.silent) : false;
    if (!contact || !user?.user_id) return
    if (!silent) setMessagesLoading(true)
    try {
    const customerId =
      contact?.conversation_type === 'group'
        ? Number(contact?.created_by || 0) || null
        : Number(contact?.user_id || contact?.conversation_id || conversationId || 0) || null
    const response = await axios.post(`${REST_API_END_POINT}chat/fetch-messages`, 
      {
        conversationId,
        userId: user.user_id,
        // Backend expects 'single' | 'group' (string), not 1 | 2
        conversationType: contact?.conversation_type === 'single' ? 'single' : 'group',
        customerId,
        chatOpenTime: compact ? null : chatOpenTime,
        selectedChatLogId: compact ? null : selectedChatLogId,
      });
    if (response.data.status === 1) {
      const messageData = response.data.messageResult || []
      const historyMessageData = response.data.historyMessageResult
      // Only use rating returned for this session — never fall back to a prior contact.chat_rating
      const nextRating = response.data.chatRating || null
      const fingerprint = messageData
        .map((m) => `${m.id}:${m.read_status}:${m.message}`)
        .join('|')
      if (silent && fingerprint === messagesFingerprintRef.current) {
        setChatRating(nextRating)
        return
      }
      messagesFingerprintRef.current = fingerprint
      setChatRating(nextRating)
      let messageArray = [];
      let historyMessageArray = [];
      for(const message of messageData){
        let newData = {
          id : message.id,
          sender : message?.sender_id === user.user_id ? 'You' : message.full_name || message.first_name || contact?.full_name || 'User',
          text : message?.message || '',
          type : message?.sender_id === user.user_id ? 'sent' : 'received',
          profile_pic : message?.profile_pic || null,
          attachment : message?.attachment_url || null,
          contentType : message?.message_type || 'text',
          chat_log_id: message?.chat_log_id || null,
          created_at: message?.created_at || 'Invalid Date',
          read_status: message?.read_status ?? null,
        }
        messageArray.push(newData)
      }
      if (endingChatRef.current && getHelpDeskChatStartedInSession(messageArray)) {
        return
      }
      setMessages(messageArray)
      const filterReceivedMessages = messageData.filter((data) => data.sender_id != user.user_id)
      const unreadMessages = filterReceivedMessages.filter(
        (data) =>
          data.read_status === 1 &&
          data.message_type !== 'system' &&
          data.message_type !== 'end' &&
          !markedReadIdsRef.current.has(Number(data.id)),
      )
      // Help desk offline: opening a chat must not mark messages read (no blue/double ticks for customer).
      // Only mark read when agent is online AND actively viewing this conversation (not the inbox list).
      const canMarkRead =
        compact
          ? helpDeskOnlineRef.current && contact && !openCompose
          : Boolean(selectedChatLogId)
      if (unreadMessages.length > 0 && ((compact && canMarkRead) || (!compact && selectedChatLogId))) {
        const unreadMessageIds = unreadMessages.map((data) => data.id)
        unreadMessageIds.forEach((id) => markedReadIdsRef.current.add(Number(id)))
        const unreadMessageIdsString = unreadMessageIds.join(',')
        const read = await axios.post(`${REST_API_END_POINT}chat/update-read-status`, {
          messageId: unreadMessageIdsString,
          userId: user.user_id,
          conversationId: conversationId,
          conversationType: contact?.conversation_type,
        })
        if (read.data.status === 1) {
          if (typeof handleRefresh === 'function') handleRefresh()
        }
      }

      for(const message of (historyMessageData || [])){
        let newData = {
          id : message.id,
          sender : message?.sender_id === user.user_id ? 'You' : message.full_name,
          text : message?.message || '',
          type : message?.sender_id === user.user_id ? 'sent' : 'received',
          profile_pic : message?.profile_pic || null,
          attachment : message?.attachment_url || null,
          contentType : message?.message_type || 'text',
          chat_log_id: message?.chat_log_id || null,
          created_at:message?.created_at || null,
          chat_log_msg:message?.chat_log_msg || message?.message || '',
          chat_log_title:message?.chat_log_title || message?.message || '',
          read_status:message?.read_status || null,
          sender_id:message?.sender_id || null,
          chatlogTime:message?.chatlogTime || null
        }
        historyMessageArray.push(newData)
      }
      setHistoryMessage(historyMessageArray)

      // setMessages([
      //   { id: 1, sender: contact.first_name, text: 'Hello!', type: 'received',profile_pic:contact.profile_pic },
      //   { id: 2, sender: 'You', text: 'Hi, how are you?', type: 'sent' }
      // ]);

    }else if (!silent){
      messagesFingerprintRef.current = ''
      setMessages([]);
    }
    } finally {
      if (!silent) setMessagesLoading(false)
    }
  };
  fetchMessagesRef.current = fetchMessages

  useEffect(() => {
    const onIncoming = (event) => {
      if (!contact || openCompose) return
      const msg = event?.detail
      if (msg?.contentType === 'chat_rating') return
      const myId = Number(user?.user_id)
      if (Number(msg?.senderId) === myId) return

      // Only refresh when the event belongs to the open thread (single chats use
      // user_<helpDesk> from the customer and user_<customer> from the agent).
      if (compact) {
        const open = contactRef.current
        const incoming = String(msg?.conversationId || '')
        const openEventId = String(conversationIdForEventRef.current || '')
        const openConvId = String(conversationIdRef.current || '')
        const senderId = Number(msg?.senderId)
        const myId = Number(user?.user_id)
        const customerId = Number(open?.user_id || openConvId)
        const isGroup = open?.conversation_type === 'group'
        const matches = isGroup
          ? incoming === openEventId ||
            incoming === `chat_${openConvId}` ||
            incoming === String(openConvId)
          : incoming === openEventId ||
            incoming === `user_${customerId}` ||
            (incoming === `user_${myId}` && senderId === customerId) ||
            senderId === customerId ||
            (senderId === myId &&
              (incoming === `user_${customerId}` || incoming === openEventId))
        if (!matches) {
          if (typeof handleRefreshRef.current === 'function') handleRefreshRef.current()
          return
        }
      }

      // Always refresh the open thread so new messages appear without a page reload
      // (including before Start Chat and after the previous session ended).
      messagesFingerprintRef.current = ''
      const leftText = String(msg?.message || msg?.text || '')
      const leftChat =
        compact &&
        (msg?.contentType === 'system' || msg?.contentType === 'end') &&
        /left the chat$/i.test(leftText.trim())
      if (leftChat && typeof setSelectedContact === 'function' && msg?.senderId) {
        setSelectedContact((prev) => {
          if (!prev?.participants?.length) return prev
          return {
            ...prev,
            participants: prev.participants.filter(
              (person) => Number(person.user_id) !== Number(msg.senderId),
            ),
          }
        })
      }
      if (
        compact &&
        isEndMessage({
          contentType: msg?.contentType,
          text: msg?.message,
          message: msg?.message,
        }) &&
        typeof setSelectedContact === 'function'
      ) {
        setSelectedContact((prev) => (prev ? { ...prev, chat_started: 0 } : prev))
      }
      if (compact) handleRefreshRef.current?.()
      setTimeout(() => {
        fetchMessagesRef.current?.({ silent: true })
      }, 400)
    }
    window.addEventListener('signwise-chat-incoming', onIncoming)
    return () => window.removeEventListener('signwise-chat-incoming', onIncoming)
  }, [contact, openCompose, compact, user?.user_id])

  const fetchGroupName = (contact) => {
    // Simulated API call to fetch group name
    const fetchedGroupName = contact.group_name || 'Unnamed Group';
    setGroupName(fetchedGroupName);
  };

  const emitStartChatEvent = (text, contentType) => {
    const participants =
      contact?.conversation_type === 'group'
        ? contact?.participants?.length
          ? contact.participants
          : [
              ...(contact?.created_by
                ? [{ user_id: Number(contact.created_by) }]
                : []),
              { user_id: HELP_DESK_USER_ID },
            ]
        : contact?.participants?.length
          ? contact.participants
          : null
    startChatSocketRef.current?.emit('message', {
      conversationId: conversationIdForEvent,
      message: text,
      sender: user,
      senderId: user.user_id,
      participants,
      selectedChatLogId: null,
      domain: DOMAIN,
      contentType,
      chatLogId: messages[0]?.chat_log_id || null,
    })
  }

  const sendStartChatMessage = async (text, messageType, chatLogIdValue) => {
    await axios.post(`${REST_API_END_POINT}chat/send-message`, {
      chatLogId: chatLogIdValue || null,
      conversation_id: conversationId,
      message: text,
      sender_id: user.user_id,
      message_type: messageType,
      attachment_url: null,
      userType: user.user_type,
      conversationType: conversationTypeValue,
    })
  }

  const handleStartChat = async () => {
    if (!compact || !contact || startingChat || chatStarted || !helpDeskOnline) return
    if (!hasPendingUserMessage(messages, 'received') && !contact?.last_message) return
    setStartingChat(true)
    try {
      const chatLogId = messages[0]?.chat_log_id || null
      await sendStartChatMessage(START_CHAT_MESSAGE, 'system', chatLogId)
      emitStartChatEvent(START_CHAT_MESSAGE, 'system')
      await sendStartChatMessage(JOIN_GREETING, 'text', chatLogId)
      emitStartChatEvent(JOIN_GREETING, 'text')
      setChatStartedLocal(true)
      if (typeof setSelectedContact === 'function' && contact) {
        setSelectedContact({ ...contact, chat_started: 1 })
      }
      await fetchMessages()
      if (typeof handleRefresh === 'function') handleRefresh()
    } catch (error) {
      console.log('Error starting help desk chat', error)
    } finally {
      setStartingChat(false)
    }
  }

  const requestEndChat = (event) => {
    event?.preventDefault?.()
    event?.stopPropagation?.()
    if (!compact || !contact || endingChatRef.current || !chatStarted) return
    setConfirmEndOpen(true)
  }

  const handleEndChat = async (event) => {
    event?.preventDefault?.()
    event?.stopPropagation?.()
    setConfirmEndOpen(false)
    if (!compact || !contact || endingChatRef.current || !chatStarted) return
    endingChatRef.current = true
    setEndingChat(true)
    setHelpDeskStatusNotices([])
    const optimistic = {
      id: `local-end-${Date.now()}`,
      sender: 'You',
      text: END_CHAT_MESSAGE,
      type: 'sent',
      profile_pic: null,
      attachment: null,
      contentType: 'end',
      chat_log_id: messages[0]?.chat_log_id || null,
      created_at: Math.floor(Date.now() / 1000),
      read_status: 1,
    }
    setMessages((prev) => [
      ...prev.filter((item) => !String(item.id).startsWith('local-end-')),
      optimistic,
    ])
    setChatStartedLocal(false)
    try {
      const chatLogId = messages[0]?.chat_log_id || null
      await sendStartChatMessage(END_CHAT_MESSAGE, 'end', chatLogId)
      emitStartChatEvent(END_CHAT_MESSAGE, 'end')
      if (typeof setSelectedContact === 'function' && contact) {
        setSelectedContact({ ...contact, chat_started: 0 })
      }
      await fetchMessages()
      if (typeof handleRefresh === 'function') handleRefresh()
    } catch (error) {
      console.log('Error ending help desk chat', error)
      setMessages((prev) => prev.filter((item) => !String(item.id).startsWith('local-end-')))
    } finally {
      endingChatRef.current = false
      setEndingChat(false)
    }
  }

  const handleSendMessage = async (value) => {
    if (compact && !chatStarted) return
    console.log(`Sending message to ${contact?.full_name || contact?.group_name}:`, value);
    let chatLogId=messages[0]?.chat_log_id || null
    await axios.post(`${REST_API_END_POINT}chat/send-message`, {
      chatLogId:chatLogId ||  null, 
      conversation_id : conversationId, 
      message : value?.message, 
      sender_id : user.user_id, 
      message_type : value?.contentType || 'text', 
      attachment_url : value?.contentType == "text" ? null : value?.attachment || null ,
      userType: user.user_type,
      conversationType: conversationTypeValue
    });
        // Notify the client after the message is persisted so attachments (e.g. video)
    // appear in the open chat without a page refresh.
    startChatSocketRef.current?.emit('message', {
      conversationId: conversationIdForEvent,
      message: value?.message || '',
      sender: user,
      senderId: user.user_id,
      participants: contact?.participants ?? null,
      selectedChatLogId: selectedChatLogId || null,
      domain: DOMAIN,
      contentType: value?.contentType || 'text',
      chatLogId: chatLogId || null,
    })
    fetchMessages(compact ? { silent: true } : undefined)
    if (!compact) handleRefresh()
    // setMessages([...messages, { id: messages.length + 1, sender: 'You', text: value?.message, type: 'sent' }]);
  };

  // if (!contact) return <Box sx={{ flexGrow: 1, textAlign: 'center', p: 3 }}>Select a contact to start chatting</Box>;

  return (
    <Box sx={{ flexGrow: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative' }}>
      {openCompose ? (
        compact ? (
          <Box
            sx={{
              flexGrow: 1,
              minHeight: 0,
              bgcolor: WA.chatBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 4,
              textAlign: 'center',
              color: WA.meta,
            }}
          >
            <Box>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '20px',
                  bgcolor: '#fff',
                  border: `1px solid ${WA.border}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 1.5,
                  color: WA.header,
                }}
              >
                <ChatIcon />
              </Box>
              <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight: 700, color: WA.text }}>
                Select a conversation
              </Typography>
              <Typography variant="body2" sx={{ maxWidth: 280, mx: 'auto' }}>
                Incoming Help Desk chats will appear in the list on the left.
              </Typography>
            </Box>
          </Box>
        ) : (
        <ChatHeaderComposeSignWise
          contacts={teamMembers}
          refreshChat={handleRefresh}
          setRenderChat={setRenderChat}
          renderChat={renderChat}
        />
        )
      ) : (
        <ChatHeaderDetailSignWise compact={compact} setOnChatScreen={setOnChatScreen} refreshChat={refreshChat} handleRefresh={handleRefresh} allContacts={teamMembers} setRenderChat={setRenderChat} renderChat={renderChat} handleOpensidebar={handleOpensidebar} contact={{ ...contact, group_name: groupName }} setSelectedContact={setSelectedContact} setCompose={setCompose} showEndChat={compact && chatStarted} onEndChat={requestEndChat} endingChat={endingChat} maximized={maximized} onToggleMaximize={onToggleMaximize} notificationsEnabled={notificationsEnabled} onToggleNotifications={onToggleNotifications} onDownloadTranscript={() => downloadChatTranscript({ messages: displayMessages, title: contact?.group_name || contact?.full_name ? `${contact.group_name || contact.full_name} transcript` : 'Help Desk chat transcript', treatYouAsAgent: true })}/>
      )}
      {!(compact && openCompose) && (
        <>
          <Divider />
          <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden', minHeight: 0 }}>
            {!openCompose && (
              <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', minWidth: 0, minHeight: 0, height: '100%', bgcolor: WA.chatBg }}>
                <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  {messagesLoading ? (
                    <Box
                      sx={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: '#fff',
                      }}
                    >
                      <CircularProgress size={28} sx={{ color: WA.header }} />
                    </Box>
                  ) : (
                  <ChatMessageListSignWise
                    messages={displayMessages || []}
                    setMessages={setMessages}
                    isTyping={isTyping}
                    typingUser={typingUser}
                    participants={contact?.participants || []}
                    recipientOnline={compact && chatStarted}
                    agentJoined={compact && chatStarted}
                    helpDeskStatusNotices={compact ? helpDeskStatusNotices : []}
                    helpDeskStatusNoticeRole="agent"
                    chatRating={chatRating}
                    showEndRating={Boolean(compact)}
                    isGroupChat={contact?.conversation_type === 'group'}
                    onReply={(msg) => {
                      const next = buildReplyTo(msg)
                      if (next) setReplyTo(next)
                    }}
                  />
                  )}
                </Box>
                <Divider />
                {compact && !chatStarted ? (
                  <Box
                    sx={{
                      px: 2,
                      py: 1.75,
                      bgcolor: '#fff',
                      borderTop: `1px solid ${WA.border}`,
                      textAlign: 'center',
                    }}
                  >
                    {waitingForUserMessage ? (
                      <Box
                        sx={{
                          px: 2,
                          py: 1.5,
                          bgcolor: WA.chatBg,
                          borderRadius: '14px',
                          border: `1px solid ${WA.border}`,
                        }}
                      >
                        <Typography variant="body2" sx={{ color: WA.text, fontWeight: 600, mb: 0.25 }}>
                          {sessionEnded
                            ? 'This chat has ended'
                            : `Waiting for ${contact?.full_name || 'this user'} to send a message`}
                        </Typography>
                        <Typography variant="caption" sx={{ color: WA.meta, display: 'block' }}>
                          {sessionEnded
                            ? 'You can start a new chat after they send another message.'
                            : 'You can start the chat after they reach out from the Help Desk widget.'}
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        <Typography variant="body2" sx={{ color: WA.text, mb: 1.25, fontWeight: 500 }}>
                          {helpDeskOnline
                            ? `${contact?.full_name || 'This user'} sent a message. Start the chat to reply.`
                            : `${contact?.full_name || 'This user'} sent a message. Go online to start this chat.`}
                        </Typography>
                        <Button
                          variant="contained"
                          onClick={handleStartChat}
                          disabled={startingChat || !helpDeskOnline}
                          sx={{
                            bgcolor: helpDeskOnline ? WA.header : '#C4CDD5',
                            color: '#fff',
                            textTransform: 'none',
                            fontWeight: 700,
                            px: 3.5,
                            borderRadius: 24,
                            boxShadow: helpDeskOnline ? '0 8px 18px rgba(2, 125, 194, 0.25)' : 'none',
                            '&:hover': { bgcolor: helpDeskOnline ? WA.headerDark : '#C4CDD5' },
                            '&.Mui-disabled': {
                              bgcolor: '#C4CDD5',
                              color: '#fff',
                            },
                          }}
                        >
                          {startingChat ? (
                            <CircularProgress size={18} sx={{ color: '#fff' }} />
                          ) : (
                            'Start Chat'
                          )}
                        </Button>
                      </>
                    )}
                  </Box>
                ) : (
                  <ChatMessageInputSignWise
                    messages={messages}
                    selectedChatLogId={selectedChatLogId}
                    setOnChatScreen={setOnChatScreen}
                    fetchMessages={fetchMessages}
                    conversationId={conversationIdForEvent}
                    onSend={handleSendMessage}
                    chat={chat}
                    setChat={setChat}
                    isTyping={isTyping}
                    setIsTyping={setIsTyping}
                    message={message}
                    setMessage={setMessage}
                    image={image}
                    setImage={setImage}
                    typingUser={typingUser}
                    setTypingUser={setTypingUser}
                    handleRefresh={handleRefresh}
                    refreshChat={refreshChat}
                    setRenderChat={setRenderChat}
                    renderChat={renderChat}
                    participants={contact?.participants ?? null}
                    sx={compact ? { minWidth: 0, maxWidth: '100%', width: '100%' } : undefined}
                    whatsapp={compact}
                    replyTo={replyTo}
                    onClearReply={() => setReplyTo(null)}
                  />
                )}
              </Box>
            )}
            {!openCompose && !compact && (
              <ChatRoomSignWise
                handleRefresh={handleRefresh}
                openSidebar={openSidebarRoom}
                setOpenSidebar={setOpenSidebarRoom}
                conversation={{}}
                participants={contact}
                setSelectedContact={setSelectedContact}
                setCompose={setCompose}
              />
            )}
          </Box>
        </>
      )}
      {confirmEndOpen && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            bgcolor: 'rgba(0, 0, 0, 0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
          onClick={() => !endingChat && setConfirmEndOpen(false)}
        >
          <Box
            onClick={(event) => event.stopPropagation()}
            sx={{
              bgcolor: '#fff',
              borderRadius: '14px',
              p: 2.5,
              width: '100%',
              maxWidth: 320,
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.18)',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: WA.text, mb: 1 }}>
              End this chat?
            </Typography>
            <Typography variant="body2" sx={{ color: WA.meta, mb: 2.5 }}>
              Are you sure you want to end this chat with {contact?.full_name || contact?.group_name || 'this user'}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Button
                onClick={() => setConfirmEndOpen(false)}
                disabled={endingChat}
                sx={{ textTransform: 'none', color: WA.meta, fontWeight: 600 }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleEndChat}
                disabled={endingChat}
                variant="contained"
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  bgcolor: WA.header,
                  '&:hover': { bgcolor: WA.headerDark },
                }}
              >
                {endingChat ? 'Ending...' : 'End Chat'}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
